import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import icCheck from '../../../assets/imgs/ic_check.svg?react';
import BoughtSpotTicket from '../../../components/BoughtSpotTicket/BoughtSpotTicket';
import CustomAntButton from '../../../components/CustomAntButton/CustomAntButton';
import styles from './styles.module.css';
import { OrderTicket, SpotInfo } from 'types';

const SpotResultScreen = memo(() => {
    const location = useLocation();
    const navigate = useNavigate();
    const {
        usedTicketQuantity,
        orderTicket,
        spotInfo,
    }: { usedTicketQuantity: number; orderTicket: OrderTicket; spotInfo: SpotInfo } = location.state ?? {};
    const { t } = useTranslation();
    const { appHomepageUrl } = JSON.parse(localStorage.getItem('APP_CONFIG') ?? '{}');

    const handleViewUsedTickets = () => {
        navigate('/bought');
    };
    const handleHomepageClick = () => {
        window.open(appHomepageUrl, '_self');
    };

    return (
        <div className={`${styles.wrapper} scrollable`}>
            <BoughtSpotTicket orderTicket={orderTicket} isTicketUsed={true} spotInfo={spotInfo} />
            <p className={styles.usedTicketQuantity}>
                {React.createElement(icCheck, { className: styles.checkIcon })}
                {t('spot-code.usage-number', { number: usedTicketQuantity })}
            </p>
            <CustomAntButton type="outlined" onClick={handleViewUsedTickets} className={styles.actionBtn} block>
                {t('button.to-ticket-list')}
            </CustomAntButton>
            {appHomepageUrl && (
                <CustomAntButton type="outlined" className={styles.actionBtn} onClick={handleHomepageClick} block>
                    {t('button.return-to-homepage')}
                </CustomAntButton>
            )}
        </div>
    );
});

export default SpotResultScreen;
